import { useState } from 'react';
import Text from 'components/Text';
import { ReactSVG } from 'react-svg';
import { disselected_audit_icon, selected_audit_icon } from 'asset/icons';

interface User {
    id: number;
    userName: string;
    isCompleted: boolean;
}

interface Props {
    label: string;
    users: User[];
    isOpen: boolean;
    onToggle: () => void
}

const SubmittedUsersDropdown = ({ label, users, isOpen, onToggle }: Props) => {
    return (
        <div className="relative">
            <div
                className="cursor-pointer text-primary underline"
                onClick={onToggle}
            >
                <Text className='text-primary' text={label} />
            </div>
            {isOpen && (
                <div className="absolute left-1/2 top-full mt-2 -translate-x-1/2 z-50 w-60 bg-white border rounded-xl shadow-lg p-2">
                    {users?.map((user) => (
                        <div
                            key={user?.id}
                            className="flex items-center justify-between py-2 px-2 border-b last:border-none"
                        >

                            <Text text={user?.userName} />

                            {user?.isCompleted ? (
                                <ReactSVG src={selected_audit_icon} />
                            ) : (
                                <ReactSVG src={disselected_audit_icon} />
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SubmittedUsersDropdown;